export const getFromLocalStorage = (name, parsingSkip) => {
	const item = localStorage.getItem(name)
	if (parsingSkip) return item
	if (item) return JSON.parse(item)
	return null
}
